const dev = {
    baseURL: 'http://rest.haikanetwork.local:3000/api/v1/'
};

const prod = {
    baseURL: 'https://rest.haikanetwork.com/api/v1/'
};

const config = process.env.NODE_ENV === 'production'
    ? prod
    : dev;

export default config;
